import {useState} from 'react';

// ! add types, should defaultVal be optional
const useChildAgePicker = ({minLimit, maxLimit, defaultVal}) => {
  const [childAgeArray, setChildAgeArray] = useState(
    defaultVal && defaultVal.length > 0 ? defaultVal : [],
  );

  const actionHandler = (index, val): boolean => {
    if (val < minLimit || val > maxLimit) {
      return;
    }

    const newChildAgeArray = [...childAgeArray];
    newChildAgeArray[index] = val;
    setChildAgeArray(newChildAgeArray);
  };

  return [childAgeArray, actionHandler, setChildAgeArray];
};

export default useChildAgePicker;
